import React, { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { CreditCard, Smartphone, Apple } from 'lucide-react';

const PaymentMethodSelector = ({ onMethodSelect, selectedMethod }) => {
  const paymentMethods = [
    {
      id: 'card',
      name: 'Carte bancaire',
      description: 'Visa, Mastercard, Amex',
      icon: CreditCard,
      color: 'from-blue-500 to-blue-600'
    },
    {
      id: 'google_pay',
      name: 'Google Pay',
      description: 'Paiement rapide et sécurisé',
      icon: Smartphone,
      color: 'from-green-500 to-green-600'
    },
    {
      id: 'apple_pay',
      name: 'Apple Pay',
      description: 'Touch ID / Face ID',
      icon: Apple,
      color: 'from-gray-700 to-black'
    }
  ];

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-4">Choisissez votre méthode de paiement</h3>
      
      <div className="grid gap-3">
        {paymentMethods.map((method) => {
          const IconComponent = method.icon;
          const isSelected = selectedMethod === method.id;
          
          return (
            <Card 
              key={method.id} 
              className={`cursor-pointer transition-all duration-200 ${
                isSelected ? 'ring-2 ring-primary border-primary' : 'hover:border-primary/50'
              }`}
              onClick={() => onMethodSelect(method.id)}
            >
              <CardContent className="p-4">
                <div className="flex items-center space-x-4">
                  <div className={`p-3 rounded-lg bg-gradient-to-r ${method.color}`}>
                    <IconComponent className="h-6 w-6 text-white" />
                  </div>
                  
                  <div className="flex-1">
                    <h4 className="font-semibold">{method.name}</h4>
                    <p className="text-sm text-muted-foreground">{method.description}</p>
                  </div>
                  
                  <div className={`w-4 h-4 rounded-full border-2 ${
                    isSelected 
                      ? 'bg-primary border-primary' 
                      : 'border-muted-foreground'
                  }`}>
                    {isSelected && (
                      <div className="w-full h-full rounded-full bg-white scale-50" />
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
      
      <div className="text-xs text-muted-foreground text-center mt-4">
        🔒 Tous les paiements sont sécurisés par Stripe
      </div>
    </div>
  );
};

export default PaymentMethodSelector;